;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="6880f58f-5db9-4f0e-ab42-d0f99cbaa5d5",e._sentryDebugIdIdentifier="sentry-dbid-6880f58f-5db9-4f0e-ab42-d0f99cbaa5d5")}catch(e){}}();import React__default from 'react';
import SearchBar from './SearchBar.js';
import styles from './SearchBar.module.scss.js';
import '../../_virtual/_sentry-release-injection-file.js';

const DesktopSearchBar = () => (React__default.createElement("div", { className: styles.desktopSearchBar, "data-zta": "header-search-bar-desktop" },
    React__default.createElement(SearchBar, { device: "desktop" })));

export { DesktopSearchBar as default };
//# sourceMappingURL=DesktopSearchBar.js.map
